export const OPTION_CATEGORY_CONFIG: Record<string, { order: number }> = {
  "1 Year Mid Curve": { order: 75 },
  "2pm": { order: 130 },
  "2 Year Mid Curve": { order: 80 },
  "3 Year Mid Curve": { order: 85 },
  "4 Year Mid Curve": { order: 90 },
  "5 Year Mid Curve": { order: 95 },
  "6Mo Mid Curve": { order: 70 },
  "9am": { order: 125 },
  "Average Price Options": { order: 155 },
  "Calendar Spread Options": { order: 145 },
  Daily: { order: 5 },
  EOM: { order: 140 },
  "Equity-Style": { order: 45 },
  Eurodollars: { order: 50 },
  "Event Contracts": { order: 210 },
  "Fed Fund Options": { order: 110 },
  "Fin Monthly": { order: 55 },
  "Fin Weekly": { order: 35 },
  "Fin Weekly Friday": { order: 205 },
  "Fin Weekly Monday": { order: 201 },
  "Fin Weekly Thursday": { order: 204 },
  "Fin Weekly Tuesday": { order: 202 },
  "Fin Weekly Wednesday": { order: 203 },
  "Fut-Style": { order: 105 },
  "Intercommodity Spread Options": { order: 150 },
  "Look-Alike": { order: 100 },
  MidCurve: { order: 65 },
  Monthly: { order: 40 },
  "New Crop": { order: 195 },
  "Premium Quoted": { order: 120 },
  Quarterly: { order: 60 },
  "Short-Dated New Crop": { order: 135 },
  "Short-Term": { order: 10 },
  SOFR: { order: 50 },
  "SOFR Monthly Options": { order: 51 },
  "Option on Strip": { order: 160 },
  Synthetic: { order: 165 },
  "Term Mid Curve": { order: 74 },
  "Vol Quoted": { order: 115 },
  "Vol Quoted Monthly": { order: 170 },
  "Vol Quoted Wkly Friday": { order: 175 },
  "Vol Quoted Wkly Wednesday": { order: 180 },
  "Weekly Friday": { order: 30 },
  "Weekly Monday": { order: 20 },
  "Weekly Thursday": { order: 27 },
  "Weekly Tuesday": { order: 22 },
  "Weekly Wednesday": { order: 25 },
};
